import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';
import { ConfirmHost } from './ui/confirm';
import { blockNativeContextMenu } from './appShell/noContextMenu';

blockNativeContextMenu(); // 통합앱에서만(웹뷰 기본 오른쪽 클릭 메뉴)
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
    <ConfirmHost />
  </StrictMode>,
);
